import { render, staticRenderFns } from "./TImeToScreen.vue?vue&type=template&id=8ac31966&scoped=true&"
import script from "./TImeToScreen.vue?vue&type=script&lang=js&"
export * from "./TImeToScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac31966",
  null
  
)

export default component.exports